import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PixHelpComponent } from '../../master/pix/help/help.component';
import { Util } from '../../utils/util';

@Component({
  selector: 'app-antifraud-warning',
  templateUrl: './antifraud-warning.component.html',
  styleUrls: ['./antifraud-warning.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class AntifraudWarningComponent implements OnInit {
  @Input() nameTransfer = '';
	@Input() valueTransferFor = 0;
	@Input() dateTransfer = '';
  @Input() label = 'Transferência para';
  @Input() title = 'Para sua segurança, a transferência abaixo está em análise!';

  constructor(
    private router: Router,
		public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  get personReceivedTransfer(): string {
    return this.nameTransfer;
  }

  get dataTransfer(): string {
    return moment(this.dateTransfer, 'DD/MM/YYYY').locale('pt-BR').format('DD MMM');
  }

  get valueTransfer(): string {
    return Util.formatValue(this.valueTransferFor);
  }

  handleCallCenter(): void {
		this.openHelpModal();
  }

	public openHelpModal() : void {
		this.handleClose();
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

  handleClose(): void {
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/antifraud-warning/antifraud-warning.component.ts